import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
    1: {
        unit: 'Review 1',
        id: 'SB4-PV-P28-E1',
        audio: '',
        video: '',
        component: UI,
        // exerciseKey: '',
        recorder: true,
        isAllowSubmit: false,
        questionImage: [ // Row
            [
                { url: 'img/FriendsPlus/Page28/E1/1.jpg' },
            ]
        ],
    },
    2: {
        unit: 'Review 1',
        id: 'SB4-PV-P28-E2',
        audio: '',
        video: '',
        component: UI,
        // exerciseKey: '',
        recorder: true,
        isAllowSubmit: false,
        questionImage: [ // Row
            [
                { url: 'img/FriendsPlus/Page28/E2/1.jpg' },
            ]
        ],
    },

}

export default json;